<app-data-table [columns]="columns" [data]="categoriesTable()" [totalRecords]="totalRecords()" [filters]="filters"
  [loading]="loading()" [cardTemplate]="card" (add)="onAdd()" (edit)="onEdit($event)"
  (removeSelected)="onRemoveSelected($event)" (pageChange)="onPage($event)" (search)="onSearch($event)" />

<ng-template #card let-category>
  <div class="surface-card shadow-2 p-3 border-round h-full flex flex-column">
    <div class="flex align-items-center justify-content-between mb-3">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center bg-purple-100 text-purple-500 border-circle w-3rem h-3rem font-bold text-xl mr-2">
          {{ category.name.charAt(0).toUpperCase() }}
        </div>
        <div>
          <div class="font-bold text-900">{{ category.name }}</div>
          <div class="text-500 text-sm">ID: {{ category.id }}</div>
        </div>
      </div>
      <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" severity="secondary"
        (onClick)="onEdit(category)"></p-button>
    </div>
  </div>
</ng-template>

<app-add-category [(visible)]="dialogVisible" [title]="dialogTitle" [subtitle]="dialogSubtitle" (save)="onSave($event)">
</app-add-category>